import React, { Component } from 'react';
import AutoPaymentInjector from '../../../library/payment/AutoPaymentInjector';
import { PaymentPGCode, ApplyTypeFrom, PaymentPlatform, ApplyChannel } from '../../../library/constants/Code';
import LoginPageInjector from '../../common/LoginPageInjector';
import DesktopLayerPopup from '../../common/DesktopLayerPopup';
import { PageLayout, ContentTemplate } from '../../common/components/layout';
import WinkPaidStudyChildSelect from './components/WinkPaidStudyChildSelect';
import WinkPaidStudyHeader from './components/WinkPaidStudyHeader';
import { api, service } from './config';
import * as MemberJoinAction from '../../../library/memberjoin/MemberJoinAction';
import { routes } from '../../../constants/routes';
import { APICaller } from '../../common/configs';
import moment from 'moment/moment';
import { getCurrentCheckList } from './config/service';
import CheckListPaid from './components/CheckListPaid';
import { getTemporaryInformationOptionalAgreementParams } from '@/library/util/TermsAgreementUtil';

const mapStateToProps = ({ MemberReducer }, ownProps) => {
    return {
        actor: MemberReducer.actor,
        auth: MemberReducer.auth,
        studentList: MemberReducer.studentList,
        studentInfo: MemberReducer.studentInfo,
        history: ownProps.history,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getTodayStudyMap: () => {
            dispatch(MemberJoinAction.getTodayStudyMap());
        },
    };
};

class WinkPaidStudy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.getInitialState(),
        };
    }

    componentDidMount() {
        const { studentList, userInfo, auth } = this.props;

        this.props.getTodayStudyMap();
        if (!userInfo.actorId) {
            this.props.history.replace('/');
            return false;
        }
        const email = auth.human_email ? auth.human_email : null;
        this.props.initPayment(PaymentPlatform.PC, window.location.origin, PaymentPGCode.LGUPlus, email);

        const { childIndex } = this.state;
        if (childIndex !== -1) {
            this.checkChildSubject(childIndex);
        }

        this.props.getStudentPaymentContractListInfo(studentList);
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedStudentInfo, studentPaymentContractListInfo } = this.props;

        if (
            JSON.stringify(studentPaymentContractListInfo) !== JSON.stringify(prevProps.studentPaymentContractListInfo)
        ) {
            this.checkPaymentList(selectedStudentInfo);
        }
    }

    getInitialState = () => {
        const { selectedStudentInfo, checkList, studentInfo, studentList } = this.props;
        let childId;
        if (selectedStudentInfo && selectedStudentInfo.id) {
            childId = selectedStudentInfo.id;
        } else if (this.props.history.query.actorid) {
            childId = parseInt(this.props.history.query.actorid, 10);
        } else {
            childId = studentInfo.id;
        }
        const childIndex = studentList
            .map((item) => item.id)
            .indexOf(childId)
            .toString();

        const newState = {
            childIndex,
            levels: checkList,
            //진단정보 show처리
            // ** 체험중인 아이기준으로 체크리스트 활성 / 비활성
            // ** isShowLevels 가 true이면 체크리스트에 체크를 해야함
            // ** isShowLevels 가 false면 체크리스트 체크 없이 통과
            isShowLevels:
                childIndex && studentList[childIndex] ? studentList[childIndex].wink_service_issue === null : false,
            //prev했을때 정보가 바뀔때만 POST 하도록 boolen값으로 컨트롤
            isChangeInfo: false,
        };

        return newState;
    };

    checkPaymentList = (selectedStudentInfo) => {
        return !(!selectedStudentInfo || Object.keys(selectedStudentInfo).length === 0);
    };

    checkChildSubject = (index) => {
        const { studentList } = this.props;
        const { childIndex } = this.state;

        const targetStudent = studentList[index];

        if (this.checkPaymentList(targetStudent) === false) {
            const memoryChildIndex = childIndex;
            this.setState({ childIndex: '' }, () => {
                this.setState({ childIndex: memoryChildIndex });
            });
            return false;
        }

        // 선택된 아이의 생일에 따른 추천 단계 설정
        // const birthday = targetStudent?.auth_detail?.birthday;
        // const recommendedCheckList = service.getCurrentLevels(birthday);
        // const currentLevels = getCurrentCheckList(recommendedCheckList);

        const newStudent = {
            ...studentList[index],
            checkList: {}, //recommendedCheckList, // 생일에 따른 추천 단계 설정
        };

        this.props.getSelectedStudentInfo(newStudent);

        // 추천 단계 설정
        // this.props.setCheckList(currentLevels);

        const isShowLevels = typeof index !== 'string' && targetStudent && targetStudent.wink_service_issue === null;
        if (isShowLevels === false) {
            if (targetStudent && targetStudent.data && targetStudent.data.levels) {
                this.props.setCheckList(targetStudent.data.levels);
            }
        }
        this.setState({ isShowLevels: isShowLevels });
        this.setChildActor(index);
    };

    setChildActor = (index) => {
        const { applyType } = this.props;

        this.setState({ childIndex: index });
        if (applyType === ApplyTypeFrom.PaidAdd) {
            this.props.setApplyType();
        }
    };

    onClickNext = (e) => {
        e.preventDefault();
        const { selectedStudentInfo, checkList } = this.props;
        const isChecked = service.isCheckedLevel(checkList);

        if (!selectedStudentInfo.id) {
            return DesktopLayerPopup.notice({
                message: '아이를 선택해 주세요',
            });
        } else if (!isChecked) {
            return DesktopLayerPopup.notice({
                message: '학습 단계를 선택해 주세요',
            });
        }

        // TODO 8월에만 8세 이상도 체험 신청 가능하도록 함. 캐츠홈 9월 배포에는 주석 해제 해야 함
        const isFalse = false;
        if (
            isFalse
            // ParentsUtil.isTargetForCatsHome(
            //   selectedStudentInfo?.sdata?.auth_detail?.birthday
            // )
        ) {
            const { url, params } = api.addTemporaryInformationActor({
                informationType: 'CatsHome',
                parentAuthHumanName: selectedStudentInfo.sdata.parent_detail?.auth_human_name,
                parentAuthHumanMdn: selectedStudentInfo.sdata.parent_detail?.auth__human_mdn,
                requestChannel: ApplyChannel.Pc,
                studentAuthHumanName: selectedStudentInfo.auth_detail?.human_name,
                studentIsMale: selectedStudentInfo.sdata.auth_detail?.is_male || false,
                studentBirthday: moment(selectedStudentInfo.sdata.auth_detail?.birthday).format('YYYY-MM-DD HH:mm:ss'),
                studentHumanPostalCode: selectedStudentInfo.sdata.parent_detail?.auth__human_postal_code,
                studentHumanAddress: selectedStudentInfo.sdata.parent_detail?.auth__human_address,
                studentHumanDetailAddress: selectedStudentInfo.sdata.parent_detail?.auth__human_detail_address,
                registeredDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                student_actor: selectedStudentInfo.id,
                ...getTemporaryInformationOptionalAgreementParams(
                    this.props.auth?.data?.terms_agreement
                ),
            });
            APICaller.post(url, params);
            return DesktopLayerPopup.notice({
                message: `<div>
            <div>윙크는 유아 전용 학습으로,</div>
            <div>초등학생인 우리아이를 위해 초등 전문학습 "캐츠홈"으로</div>
            <div>학습을 시작 하실 수 있도록 곧 연락드리겠습니다.</div>
            <div>(영업일 기준 1~2일 이내)</div>
          </div>`,
            });
        }

        return this.props.history.push(routes.wink.paidStudyStep02);
    };

    render() {
        const { childIndex, isShowLevels } = this.state;
        const { studentList, selectedStudentInfo } = this.props;

        return (
            <PageLayout>
                <ContentTemplate>
                    <div id="contents" className="wink-paid-study step-1">
                        <WinkPaidStudyHeader step={1} />
                        <WinkPaidStudyChildSelect
                            checkChildSubject={this.checkChildSubject}
                            childIndex={childIndex}
                            availableStudents={studentList}
                            {...this.props}
                        />
                        {selectedStudentInfo?.id && isShowLevels === true && (
                            <CheckListPaid studentInfo={selectedStudentInfo} />
                        )}
                        <div className="new-btn-area">
                            <a href="#" className="new-btn btn-confirm" onClick={this.onClickNext}>
                                다음 단계로
                            </a>
                        </div>
                    </div>
                </ContentTemplate>
            </PageLayout>
        );
    }
}

export default LoginPageInjector(AutoPaymentInjector(mapStateToProps, mapDispatchToProps)(WinkPaidStudy));
